
import FormStore from '@/store/formStore';
import { Component, Vue } from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import StepCol from '@/components/layout/StepCol.vue';
import CreateDebtorDialog from '@/components/dialogs/CreateDebtorDialog.vue';

@Component({
  components: {
    StepCol,
    CreateDebtorDialog,
  },
  filters: {
    censor(): string {
      return '••••••••••';
    },
  },
})
export default class BasicInfoSummary extends Vue {
  // VUEX MODULES
  formStore: FormStore | null = null;

  // HOOKS
  created() {
    this.formStore = getModule(FormStore);
    this.$nextTick(() => {
      window.scrollTo(0, 0);
    });
  }
}
